<template>
<div>
  <div id="wjdcEdit" v-if="editFlag">
      <div id="wjdcView" class="pt15">
        <el-form class="el-form demo-form-inline" ref="wjdcForm" :model="wjdcForm" label-position="right" label-width="200px" :rules="wjdcRules">
          <el-row class="tr mb5">
            <el-col :span="22">
              <el-form-item prop="gsxz" label="公司性质" style="text-align: left">
                <el-radio-group v-model="wjdcForm.gsxz" size="small" auto-complete="off">
                  <el-radio v-for="item in gsxz_data" :label="item.codeValue" :key="item.codeValue" class="radio">
                    <span v-text="item.codeName"></span>
                  </el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col :span="2">&nbsp;</el-col>
          </el-row>
          <el-row class="tr mb5">
            <el-col :span="22">
              <el-form-item prop="sfhwdlcp" label="是否代理海外产品" style="text-align: left">
                <el-radio-group v-model="wjdcForm.sfhwdlcp" size="small" auto-complete="off" @change="sfhwdlcpChange()">
                  <el-radio class="radio" :label="'1'">是</el-radio>
                  <el-radio class="radio" :label="'0'">否</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col :span="2">&nbsp;</el-col>
          </el-row>
          <el-row class="tr mb5" v-show="ishwdlcp">
            <el-col :span="12">
              <el-form-item prop="hwdlcppp" label="代理海外产品品牌" :rules="this.ishwdlcp?wjdcRules.hwdlcppp:[{ required: false, message: '请输入产品品牌', trigger: 'blur' }]">
                <el-input size="small" v-model="wjdcForm.hwdlcppp" placeholder="代理海外产品品牌"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="2">&nbsp;</el-col>
          </el-row>
          <el-row class="tr mb5">
            <el-col :span="22">
              <el-form-item prop="fmzl" label="发明专利(项)">
                <el-input-number v-model="wjdcForm.fmzl" size="small" :min="0" :max="10000" :precision="0" label="发明专利(项)"></el-input-number>
              </el-form-item>
            </el-col>
            <el-col :span="2">&nbsp;</el-col>
          </el-row>
          <el-row class="tr mb5">
            <el-col :span="22">
              <el-form-item prop="syxxzl" label="实用新型专利(项)">
                <el-input-number v-model="wjdcForm.syxxzl" size="small" :min="0" :max="10000" :precision="0" label="实用新型专利(项)"></el-input-number>
              </el-form-item>
            </el-col>
            <el-col :span="2">&nbsp;</el-col>
          </el-row>
          <el-row class="tr mb5">
            <el-col :span="22">
              <el-form-item prop="wgsjzl" label="外观设计专利(项)">
                <el-input-number v-model="wjdcForm.wgsjzl" size="small" :min="0" :max="10000" :precision="0" label="外观设计专利(项)"></el-input-number>
              </el-form-item>
            </el-col>
            <el-col :span="2">&nbsp;</el-col>
          </el-row>
          <el-row class="tr mb5">
            <el-col :span="22">
              <el-form-item prop="sfgxjsqy" label="是否为高新技术企业" style="text-align: left">
                <el-radio-group v-model="wjdcForm.sfgxjsqy" size="small" auto-complete="off" @change="sfgxjsqyChange()">
                  <el-radio class="radio" :label="'1'">是</el-radio>
                  <el-radio class="radio" :label="'0'">否</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col :span="2">&nbsp;</el-col>
          </el-row>
          <el-row class="tr mb5" v-show="isgxjsqy">
            <el-col :span="22">
              <el-form-item label="企业高新技术级别" prop="gxjsjb" :rules="this.isgxjsqy?wjdcRules.gxjsjb:[{ required: false, message: '请选择企业高新技术级别', trigger: 'blur' }]" style="text-align: left">
                <el-radio-group v-model="wjdcForm.gxjsjb" size="small" auto-complete="off">
                  <el-radio v-for="item in gxjsjb_data" :label="item.codeValue" :key="item.codeValue" class="radio">
                    <span v-text="item.codeName"></span>
                  </el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col :span="2">&nbsp;</el-col>
          </el-row>
          <el-row class="tr mb5">
            <el-col :span="22">
              <el-form-item prop="isgjrz" label="贵公司产品是否有国际认证" style="text-align: left">
                <el-checkbox-group v-model="wjdcForm.gjrzList">
                  <el-checkbox v-for="item in gjrz_data" :label="item.codeValue" :key="item.codeValue">{{item.codeName}}</el-checkbox>
                </el-checkbox-group>
              </el-form-item>
            </el-col>
            <el-col :span="2">&nbsp;</el-col>
          </el-row>
          <el-row class="tr mb5" v-if="wjdcForm.gjrzList.includes('99')">
            <el-col :span="11">
              <el-form-item label="其他认证名称" prop="qtgjrz" style="text-align: left">
                <el-input size="small" v-model="wjdcForm.qtgjrz" placeholder="其他认证名称"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="2">&nbsp;</el-col>
          </el-row>
          <el-row class="tr mb5">
            <el-col :span="22" style="text-align:left">
              <el-form-item label="公司主营产品类型" prop="zycpList" id="cplx_btn_group">
                <el-button v-for="item in zycp_data" :key="item.codeValue" plain size="small" @click="selectCpfl(item.codeValue)">
                  <span v-text="item.codeName"></span>
                </el-button>
              </el-form-item>
            </el-col>
            <el-col :span="2">&nbsp;</el-col>
          </el-row>
          <el-row class="tr mb5">
            <el-col :span="22" style="text-align:left;margin-left: 200px;">
                <el-button type="primary" v-for="item in childrenCpfl" :key="item.codeValue" plain size="small" @click="selectCpfl2(item.codeValue)">
                  <span v-text="item.codeName"></span>
                </el-button>
            </el-col>
            <el-col :span="2">&nbsp;</el-col>
          </el-row>
          <el-row id="childrenRow" class="tr mb5" style="text-align:left">
            <el-col :span="22" style="text-align: left;">
              <el-row id="tagRow" class="tr mb5">
                <el-col :span="19" style="text-align: left;margin-left: 200px;">
                  <el-checkbox-group v-model="wjdcForm.zycpList" id="cplx_chb_group">
                    <el-checkbox v-for="item in grandchildrenCpfl" :label="item.codeValue+item.codeName" :key="item.codeValue+item.codeName">{{item.codeName}}</el-checkbox>
                  </el-checkbox-group>
                </el-col>
              </el-row>
              <el-row id="tagRow" class="tr mb5">
                <el-col :span="19" style="text-align: left;margin-left: 200px;">
                  <el-tag v-for="tag in wjdcForm.zycpList" :key="tag" closable @close="handleTagClose(tag)" style="margin: 3px"  type= 'success'>
                    {{tag.substr(4)}}
                  </el-tag>
                </el-col>
              </el-row>
            </el-col>
            <el-col :span="2">&nbsp;</el-col>
          </el-row>
         
          <el-row class="buttonSubmit">
            <el-col :span="24">
              <el-button v-if="wjdcData.validateFlag=='T'" type="info" icon="el-icon-close" size="small" class="btn_submit" @click="cancel()">取消</el-button>
              <el-button type="success" icon="el-icon-check" size="small" class="btn_submit" @click="submitWjdc('wjdcForm')">保存</el-button>
            </el-col>
          </el-row>
        </el-form>
      </div>
  </div>
  <div class="main-container" element-loading-text="加载中" v-if="!editFlag">
    <div id="qywjdc" class="mb5">
      <el-row>
            <el-col :span="1">&nbsp;</el-col>
            <el-col :span="21">
              <el-row class="mb10">
                <strong>公司性质：</strong>
                <span v-text="wjdcData.gsxzmc||'无'"></span>
              </el-row>
              <el-row class="mb10">
                <strong>主营产品：</strong>
                <span v-text="wjdcData.zycp||'无'"></span>
              </el-row>
              <el-row class="mb10">
                <el-col :span="12">
                  <strong>是否代理海外产品：</strong>
                  <span v-text="wjdcData.sfhwdlcp==1?'是':wjdcData.sfhwdlcp==0?'否':'无'"></span>
                </el-col>
                <el-col :span="12">
                  <strong>海外代理产品品牌：</strong>
                  <span v-text="wjdcData.hwdlcppp||'无'"></span>
                </el-col>
              </el-row>
              <el-row class="mb10">
                <el-col :span="12">
                  <strong>是否高新技术企业：</strong>
                  <span v-text="wjdcData.sfgxjsqy==1?'是':wjdcData.sfgxjsqy==0?'否':'无'"></span>
                </el-col>
                <el-col :span="12">
                  <strong>高新技术级别：</strong>
                  <span v-text="wjdcData.gxjsjbmc||'无'"></span>
                </el-col>
              </el-row>
              
              <el-row class="mb10">
                <el-col :span="12">
                  <strong>发明专利(项)：</strong>
                  <span v-text="wjdcData.fmzl||'无'"></span>
                </el-col>
                <el-col :span="12">
                  <strong>实用新型专利(项)：</strong>
                  <span v-text="wjdcData.syxxzl||'无'"></span>
                </el-col>
              </el-row>
              <el-row class="mb10">
                <el-col :span="12">
                  <strong>外观设计专利(项)：</strong>
                  <span v-text="wjdcData.wgsjzl||'无'"></span>
                </el-col>
              </el-row>
              <el-row class="mb10">
                <el-col :span="12">
                  <strong>贵公司产品是否有国际认证：</strong>
                  <span v-text="wjdcData.gjrzstr||'无'"></span>
                </el-col>
                <el-col :span="12" v-if="wjdcData.gjrz && wjdcData.gjrz.includes('99')">
                  <strong>其他认证名称：</strong>
                  <span v-text="wjdcData.qtgjrz||'无'"></span>
                </el-col>
              </el-row>
            </el-col>
            <el-col :span="2">
              <el-button type="primary" icon="el-icon-edit" size="small" class="btn_submit" @click="editClick()">编辑</el-button>
            </el-col>
      </el-row>
    </div>
  </div>
</div>
</template>

<script>
export default {
  props:{
    qyid: {
        type: String,
        required: true
    },
  },
  
  name: "wjdcEdit",
  data() {
    return {
      //当前用户
      currentUser: this.CONSTANT.currentUser,
      //问卷调查产品分类子类
      childrenCpfl: [],
      //问卷调查表单
      wjdcForm: {
        uuid: "",
        gsxz:"",
        sfhwdlcp:"",
        hwdlcppp:"",
        fmzl: "",
        syxxzl: "",
        wgsjzl: "",
        sfgxjsqy:"",
        gxjsjb:"",
        zycpList: [],
        sfhyxydj:"",
        hyxydj:"",
        gjrzList: []
      },
      wjdcRules: {
        gsxz: [
          { required: true, message: "请选择公司性质", trigger: "change" }
        ],
        sfhwdlcp: [
          {
            required: true,
            message: "请选择是否代理海外产品",
            trigger: "change"
          }
        ],
        hwdlcppp: [
          { required: true, message: "请输入产品品牌", trigger: "blur" },
          { min: 1, max: 100, message: "最多可输入100个字", trigger: "blur" }
        ],
        fmzl: [
          { required: true, message: "请输入发明专利(项)", trigger: "blur" }
        ],
        syxxzl: [
          { required: true, message: "请输入实用新型专利(项)", trigger: "blur" }
        ],
        wgsjzl: [
          { required: true, message: "请输入外观设计专利(项)", trigger: "blur" }
        ],
        sfgxjsqy: [
          {
            required: true,
            message: "请选择是否为高新技术企业",
            trigger: "change"
          }
        ],
        gxjsjb: [
          { required: true, message: "请选择高新技术级别", trigger: "change" }
        ],
        sfhyxydj: [
          {
            required: true,
            message: "请选择是否在2018年参与中国消防协会消防行业信用等级评价",
            trigger: "change"
          }
        ],
        hyxydj: [
          { required: true, message: "请选择行业信用等级", trigger: "change" }
        ],
        zycpList: [
          { required: true, message: "请选择主营产品类型号", trigger: "change" }
        ],
        qtgjrz: [
          { required: true, message: "请填写其他认证名称", trigger: "blur" },
          { min: 1, max: 100, message: "最多可输入100个字", trigger: "blur"}
        ]
      },
      //代理海外产品flag
      ishwdlcp: false,
      //是否高新技术企业flag
      isgxjsqy: false,
      //是否行业信用等级flag
      isSfhyxydj: false,
      //问卷调查产品类型选择标识
      isCplxSelect: false,
      //公司性质data
      gsxz_data: [],
      //高新技术级别data
      gxjsjb_data: [],
      //公司主营产品
      zycp_data: [],
      //行业信用等级
      hyxydj_data: [],

      editFlag: false,
      //企业问卷调查
      wjdcData: {},
      gjrz_data:[],
      isQtrz: false,
      grandchildrenCpfl:[]
    };
  },
  watch: {
    qyid(){
      if(this.qyid == 'newInsert'){
        this.editFlag = true;
      }else if(this.qyid != ''){
        this.findWjdcByQyid(this.qyid);
      }
    },
  },
  created: function() {
    this.getGjrz();//国际认证
    this.getGsxz(); //公司性质
    this.getGxjsjb(); //高新技术级别
    this.getCplx(); //产品类型
    //this.getHyxydj(); //行业信用等级
  },
  methods: {
   //根据代码集获取公司性质
    getGsxz: function() {
      let vm = this;
      vm.$axios.get("/codelist/getCodetype/GSXZ").then(
        function(res) {
          vm.gsxz_data = res.data.result;
        }.bind(vm),
        function(error) {
          console.log(error);
        }
      );
    },
    //根据代码集获取高新技术级别
    getGxjsjb: function() {
      let vm = this;
      vm.$axios.get("/codelist/getCodetype/GXJSJB").then(
        function(res) {
          vm.gxjsjb_data = res.data.result;
        }.bind(vm),
        function(error) {
          console.log(error);
        }
      );
    },
    //根据代码集获取公司主营产品tree
    getCplx: function() {
      let vm = this;
      vm.$axios.post("/codelist/getZycpTree/CPLX").then(
        function(res) {
          vm.zycp_data = res.data.result;
        }.bind(vm),
        function(error) {
          console.log(error);
        }
      );
    },
    //根据代码集获取行业信用等级
    getHyxydj: function() {
      let vm = this;
      vm.$axios.get("/codelist/getCodetype/HYXYDJ").then(
        function(res) {
          vm.hyxydj_data = res.data.result;
        }.bind(vm),
        function(error) {
          console.log(error);
        }
      );
    },
    //根据代码集获取国际认证
    getGjrz: function() {
      let vm = this;
      vm.$axios.get("/codelist/getCodetype/GJRZ").then(
        function(res) {
          vm.gjrz_data = res.data.result;
        }.bind(vm),
        function(error) {
          console.log(error);
        }
      );
    },

    //通过企业id查找问卷调查信息
    findWjdcByQyid: function(qyid) {
      let vm = this;
      vm.loading = true;
      var params = {
        qyid: qyid,
        deleteFlag: "N"
      };
      vm.$axios.post("/qywjdc/list", params).then(
        function(res) {
          if (res.data.result.length > 0) {
            this.wjdcData = JSON.parse(JSON.stringify(res.data.result[0]));
            if(vm.wjdcData.reserve1 != null && vm.wjdcData.reserve1 !=''&&vm.wjdcData.reserve1 != undefined){
            var tempList = this.wjdcData.reserve1.split(",");
            }else{
              tempList=[]
            }
            var zycp = "";
            for (var i in tempList) {
              zycp = zycp + tempList[i].substr(4) + "、";
            }
            this.wjdcData.zycp = zycp.substr(0, zycp.length - 1);
            vm.wjdcForm = res.data.result[0];
            if(res.data.result[0].validateFlag == 'T'){
                vm.editFlag = false;
            }else{
                vm.editFlag = true;
            }

            vm.wjdcForm.zycpList = [];
            if (vm.wjdcForm.sfhwdlcp == "1") {
              //海外产品代理
              vm.ishwdlcp = true;
            }else{
              vm.ishwdlcp = false;
            }
            if (vm.wjdcForm.sfgxjsqy == "1") {
              //是否为高新技术企业
              vm.isgxjsqy = true;
            }else{
              vm.isgxjsqy = false;
            }
            // if (vm.wjdcForm.sfhyxydj == "1") {
            //   //是否在2018年参与中国消防协会消防行业信用等级评价
            //   vm.isSfhyxydj = true;
            // }else{
            //   vm.isSfhyxydj = false;
            // }
        
            if(vm.wjdcForm.reserve1 != null && vm.wjdcForm.reserve1 !=''&&vm.wjdcForm.reserve1 != undefined){
              var tempList = vm.wjdcForm.reserve1.split(",");
              for (var i in tempList) {
                vm.wjdcForm.zycpList.push(tempList[i]);
              }
            }else{
              vm.wjdcForm.zycpList = []
            }

            vm.wjdcForm.gjrzList = [];
            if(vm.wjdcForm.gjrz){
              let tempGjrzList = vm.wjdcForm.gjrz.split(",");
              for (var i in tempGjrzList) {
                vm.wjdcForm.gjrzList.push(tempGjrzList[i]);
              }
            }

          } else {
            vm.editFlag = true;
            vm.wjdcForm = {
              uuid: "",
              gsxz:"",
              sfhwdlcp:"",
              hwdlcppp:"",
              fmzl: "",
              syxxzl: "",
              wgsjzl: "",
              sfgxjsqy:"",
              gxjsjb:"",
              zycpList: [],
              sfhyxydj:"",
              hyxydj:"",
              gjrzList: []
            };
          }
          vm.loading = false;
        }.bind(vm),
        function(error) {
          console.log(error);
        }
      );
    },
    //选择产品分类，显示子类
    selectCpfl: function(codeValue) {
      //清空孙子
      this.grandchildrenCpfl = [];
      //遍历儿子
      for (var i in this.zycp_data) {
        if (this.zycp_data[i].codeValue == codeValue) {
          this.childrenCpfl = this.zycp_data[i].children;
        }
      }
      //document.getElementById("childrenRow").innerHTML="";
    },

    //选择产品分类，显示子类
    selectCpfl2: function(codeValue) {
      for (var i in this.childrenCpfl) {
        if (this.childrenCpfl[i].codeValue == codeValue) {
          this.grandchildrenCpfl = this.childrenCpfl[i].children;
        }
      }
      //document.getElementById("childrenRow").innerHTML="";
    },
    //关闭标签
    handleTagClose: function(tag) {
      this.wjdcForm.zycpList.splice(this.wjdcForm.zycpList.indexOf(tag), 1);
    },
    //是否代理海外产品change
    sfhwdlcpChange: function() {
      if (this.wjdcForm.sfhwdlcp == "1") {
        //是
        this.ishwdlcp = true;
      } else {
        this.ishwdlcp = false;
        this.wjdcForm.hwdlcppp = "";
      }
    },
    //是否高新技术企业change
    sfgxjsqyChange: function() {
      if (this.wjdcForm.sfgxjsqy == "1") {
        //是
        this.isgxjsqy = true;
      } else {
        this.isgxjsqy = false;
        this.wjdcForm.gxjsjb = "";
      }
    },
    //是否行业信用等级change
    sfhyxydjChange: function() {
      if (this.wjdcForm.sfhyxydj == "1") {
        //是
        this.isSfhyxydj = true;
      } else {
        this.isSfhyxydj = false;
        this.wjdcForm.hyxydj = "";
      }
    },
    //问卷调查上一步
    cancelWjdc: function() {
      this.$emit("getActive",  1);
    },
    //问卷调查提交（下一步）
    submitWjdc: function(formName) {
      let vm = this;
      if (vm.qyid == 'newInsert') {
        vm.$alert("保存失败，请先填写企业基本信息后再填写其他信息", '提示', {
          confirmButtonText: '确定'
        });
      }else{
        vm.$refs[formName].validate(valid => {
        if (valid) {
          vm.loading = true;
          var zycp = "";
          var reserve1 = "";
          for (var i in vm.wjdcForm.zycpList) {
              var str = vm.wjdcForm.zycpList[i].substr(0, 4) + ",";
              zycp += str;
              reserve1 += vm.wjdcForm.zycpList[i] + ",";
          }
          var params = {
            uuid: vm.wjdcForm.uuid,
            qyid: vm.qyid,
            gsxz: vm.wjdcForm.gsxz,
            sfhwdlcp: vm.wjdcForm.sfhwdlcp,
            hwdlcppp: vm.wjdcForm.hwdlcppp,
            fmzl: vm.wjdcForm.fmzl,
            syxxzl: vm.wjdcForm.syxxzl,
            wgsjzl: vm.wjdcForm.wgsjzl,
            sfgxjsqy: vm.wjdcForm.sfgxjsqy,
            gxjsjb: vm.wjdcForm.gxjsjb,
            zycp: zycp.substr(0, zycp.length - 1), //eg.1001,1002,1003
            sfhyxydj: vm.wjdcForm.sfhyxydj,
            hyxydj: vm.wjdcForm.hyxydj,
            xgrid: vm.currentUser.userid,
            xgrmc: vm.currentUser.username,
            reserve1: reserve1.substr(0, reserve1.length - 1), //eg.1001消防车
            validateFlag: 'T',
            gjrz: vm.wjdcForm.gjrzList.join(","),
            //qtgjrz: vm.wjdcForm.qtgjrz
          };
          if(vm.wjdcForm.gjrzList.includes("99")){
            params.qtgjrz = vm.wjdcForm.qtgjrz
          }else{
            params.qtgjrz = ''
          }
          //处理产品是否有国际认证，获取中文标签
          if(vm.wjdcForm.gjrzList.length >0){
            //排序
            let temp_list = vm.wjdcForm.gjrzList.sort((a, b) => a - b);
            let gjrzStr = "";
            for(let i in temp_list){
              let codeName = this.getFieldValue(this.gjrz_data,'codeValue', temp_list[i], 'codeName')
              gjrzStr = gjrzStr + codeName + "、";
            }
            //存一下中文标签
            params.gjrzstr = gjrzStr.substr(0, gjrzStr.length - 1);
          }
          vm.$axios.post("/qywjdc/doInsertOrUpdateWjByVo", params).then(
              function(res) {
                if (res.data.result != null && res.data.result != "") {
                  vm.$message({
                    message: "企业其他信息暂存成功",
                    type: "success"
                  });
                 
                  vm.$emit("getLoading", false);
                  //this.$emit("getActive",  3);
                  vm.editFlag = false;
                  vm.findWjdcByQyid(this.qyid);
                  
                } else {
                  vm.$message({
                    message: "企业其他信息暂存失败",
                    type: "error"
                  });
                  vm.$emit("getLoading", false);
                }
              }.bind(vm),
              function(error) {
                console.log(error);
              }
            );
        } else {
          setTimeout(() => {
              var isError = document.getElementsByClassName("is-error");
              isError[0].querySelector('input,textarea').focus();
            }, 100);
          console.log("error submit!!");
          return false;
        }
      });
    
      }
      },

    editClick: function(){
      this.editFlag = true;
    },
    cancel: function(){
      this.findWjdcByQyid(this.qyid);
    },
    //匹配代码集
    getFieldValue (store, inField, inFieldValue, outField) {
      let res = ''
      let item = store.find(item => item[inField] === inFieldValue)
      if (item) {
        res = item[outField]
      }
      return res
    },
  }
};
</script>

<style lang="scss">
#wjdcEdit {
  .mb5 {
    margin-bottom: 5px;
  }
  
  .el-card__body {
    padding: 10px 0px 10px 0px;
  }
  .el-message {
    z-index: 10005 !important;
  }

  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409eff;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 100px;
    height: 100px;
    line-height: 100px;
    text-align: center;
  }
  .avatar {
    width: 100px;
    height: 100px;
    display: block;
  }
  .el-dialog {
    width: 45%;
  }
  .el-button--small {
    padding: 9px 9px;
  }

  .card_title_font{
    line-height: 40px;
  }
  .clearfix{
    height: 40px;
  }
  #wjdcView .el-input-number--small{
    width: 30%;
    float: left;
  }
  
}
</style>



// WEBPACK FOOTER //
// src/views/exhibition/prediction/exhprediction/exhpredictionEdit/Wjdc.vue